module.exports = require("util");


/*****************
 ** WEBPACK FOOTER
 ** external "util"
 ** module id = 337
 ** module chunks = 0
 **/